var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { css } from "emotion";
import { getThemeColorVar } from "../helper/color";
import { BareSidePanel } from "./baresidepanel";
import { HorizontalForm } from "./horizontalform";
import { FlexContainer } from "../grid/flexcontainer";
import { Button } from "./button";
import Icon from "./icon";
import { bind } from "decko";
const sidePanelTitleClass = css({
    marginTop: "24px",
    marginBottom: "48px",
});
const sidePanelMainTitleClass = css({
    color: getThemeColorVar("typo", "dark"),
    fontSize: "30px",
    lineHeight: "30px",
    fontWeight: 300,
});
const sidePanelSubtitleClass = css({
    color: getThemeColorVar("typo", "light"),
    fontSize: "16px",
    lineHeight: "22px",
    fontWeight: 400,
    marginTop: "24px",
    whiteSpace: "pre-wrap",
});
const sidePanelCloseButtonClass = css({
    cursor: "pointer",
    textAlign: "right",
    minHeight: "20px",
});
export class SidePanel extends React.Component {
    render() {
        const { children, actions, opened, sticky, title, subtitle, onClose } = this.props;
        return (React.createElement(BareSidePanel, { sticky: sticky, opened: opened, onClose: onClose },
            React.createElement(HorizontalForm, { padding: 24, header: React.createElement(FlexContainer, { direction: "col" },
                    React.createElement("div", { className: sidePanelCloseButtonClass, onClick: this.handleCloseButton },
                        React.createElement(Icon, { name: "close", color: "primary", colorType: "default" })),
                    React.createElement("div", { className: sidePanelTitleClass },
                        React.createElement("div", { className: sidePanelMainTitleClass }, title),
                        subtitle && (React.createElement("div", { className: sidePanelSubtitleClass }, subtitle)))), actionBar: React.createElement(FlexContainer, { direction: "row-reverse", gap: 16, padding: [24, 0, 0, 0] }, actions &&
                    actions.map((action, idx) => idx === 0 ? (React.createElement(Button, { type: "primary", formType: "submit", key: idx, onClick: action.action, icon: action.icon, disabled: action.disabled }, action.label)) : (React.createElement(Button, { type: "secondary", formType: "button", key: idx, onClick: action.action, icon: action.icon, disabled: action.disabled }, action.label)))) }, children)));
    }
    handleCloseButton(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onClose && this.props.onClose();
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SidePanel.prototype, "handleCloseButton", null);
export default SidePanel;
//# sourceMappingURL=sidepanel.js.map